import { EuiIcon } from "@inscopix/ideas-eui";
import { CSSProperties } from "react";
import { TABLE_ICONS } from "types/Icons";
import { workflowDiagramStyles } from "../workflowDiagramStyles";
import { LegendRow } from "./LegendRow";

export const legendStyles = {
  swatchBase: {
    width: 36,
    height: 18,
    boxSizing: "border-box",
    border: "1.5px solid rgba(26, 28, 33, 0.55)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } satisfies CSSProperties,
  sectionHeading: {
    fontWeight: 600,
    fontSize: 11,
    margin: "8px 0 2px",
    opacity: 0.7,
  } satisfies CSSProperties,
};

export interface WorkflowGraphLegendProps {
  hasInputs: boolean;
  hasSteps: boolean;
  hasKeptOutputs: boolean;
  hasDiscardedOutputs: boolean;
  hasEdges: boolean;
}

export const WorkflowGraphLegend = ({
  hasInputs,
  hasSteps,
  hasKeptOutputs,
  hasDiscardedOutputs,
  hasEdges,
}: WorkflowGraphLegendProps) => {
  const hasNodes =
    hasInputs || hasSteps || hasKeptOutputs || hasDiscardedOutputs;
  if (!hasNodes && !hasEdges) return null;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #d3dae6",
        borderRadius: 6,
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.12)",
        padding: "8px 12px",
        fontSize: 14,
        lineHeight: 1.3,
        width: 270,
        color: workflowDiagramStyles.colors.text,
      }}
    >
      <details open>
        <summary style={{ cursor: "pointer", fontWeight: 600, fontSize: 13 }}>
          Legend
        </summary>

        {hasNodes && <div style={legendStyles.sectionHeading}>Node types</div>}
        {hasInputs && (
          <LegendRow
            swatch={
              <div
                style={{
                  ...legendStyles.swatchBase,
                  ...workflowDiagramStyles.shapes.input,
                }}
              >
                <EuiIcon type={TABLE_ICONS["input"]} size="s" />
              </div>
            }
            title="Inputs"
            description="File inputs"
          />
        )}
        {hasSteps && (
          <LegendRow
            swatch={
              <div
                style={{
                  ...legendStyles.swatchBase,
                  ...workflowDiagramStyles.shapes.step,
                }}
              >
                <EuiIcon type={TABLE_ICONS["analysis"]} size="s" />
              </div>
            }
            title="Steps"
            description="Tools"
          />
        )}
        {hasKeptOutputs && (
          <LegendRow
            swatch={
              <div
                style={{
                  ...legendStyles.swatchBase,
                  ...workflowDiagramStyles.shapes.keep,
                }}
              >
                <EuiIcon type={TABLE_ICONS["output"]} size="s" />
              </div>
            }
            title={hasDiscardedOutputs ? "Outputs: Kept" : "Outputs"}
            description="Tool Result Files"
          />
        )}
        {hasDiscardedOutputs && (
          <LegendRow
            swatch={
              <div
                style={{
                  ...legendStyles.swatchBase,
                  ...workflowDiagramStyles.shapes.discard,
                }}
              >
                <EuiIcon type={TABLE_ICONS["output"]} size="s" />
              </div>
            }
            title="Outputs: Discarded"
            description="Tool Result Files (Discarded after workflow completion)"
          />
        )}
      </details>
    </div>
  );
};
